import { type FC, useEffect, useState } from 'react';

import Link from 'next/link';

import { Pill } from '@gds/Pill/Pill';
import { Typography } from '@gds/Typography/Typography';
import { KenticoImage } from '@shared-components/KenticoImage/KenticoImage';

import type { UspPillsProps } from './UspPills.entity';

import styles from './UspPills.module.css';

const UspPills: FC<UspPillsProps> = ({ usps }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % usps.uspItems.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [usps.uspItems.length]);

  return (
    <>
      <div className={styles.scrollWrapper}>
        {usps.uspItems.map((uspItem, index) => (
          <div
            key={index}
            className={`${styles.scrollItem} ${index === currentIndex ? styles.visible : ''}`}
          >
            <Pill className={styles.label}>
              <div className={styles.uspIcon}>
                <KenticoImage
                  src={uspItem.image[0]}
                  alt={uspItem.title}
                  fill
                  style={{ objectFit: 'contain' }}
                  sizes="(max-width: 768px) 20vw, (max-width: 1200px) 33vw"
                  loading="eager"
                />
              </div>
              {uspItem.description}
            </Pill>
          </div>
        ))}
      </div>
      {usps.uspLink[0]?.ctaText && (
        <Link href={usps.uspLink[0]?.link ?? '/'} key={usps.uspLink[0]?.ctaText} target="_blank">
          <Typography className={styles.link} variant="buttonLink2">
            {usps.uspLink[0]?.ctaText}
          </Typography>
        </Link>
      )}
    </>
  );
};

export default UspPills;
